var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CurrentGuess"},[_vm._l((_vm.currentGuess),function(pin,guessID){return _c('GuessPin',{key:guessID,attrs:{"id":guessID,"pin":pin}})}),_c('div',{staticClass:"CurrentGuess-testButton"},[_c('BaseButton',{attrs:{"label":"Test"},on:{"click":_vm.testCode}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }